/* eslint-disable no-multi-assign */
import jQuery from 'jquery'

// exportando jQuery globalmente
window.$ = window.jQuery = jQuery
